import React from 'react';
import { graphql } from 'gatsby';
import Intro from 'features/contact-us/Intro';
import Main from 'components/UI/Main';
import ShortCustomers from 'features/common/ShortCustomers';
import StepsCalculator from 'features/common/StepsCalculator';
import OurOffices from 'features/common/OurOffices';
import Testimonials from 'features/common/Testimonials';
import SEO from 'components/SEO';

import data from './data.json';

export default function Pricing({ data: { introImagesJson: hero }, pageContext: { pagePath } }) {
  return (
    <>
      <Intro {...data.intro} gatsbyImage={hero} />
      <Main>
        <ShortCustomers />
        <StepsCalculator />
        <OurOffices />
        <Testimonials pageKey={pagePath} {...data.reviews} />
      </Main>
    </>
  );
}

export const Head = ({ location }) => <SEO {...data.head} {...location} />;

export const query = graphql`
  query ($pagePath: String) {
    introImagesJson(page: { eq: $pagePath }) {
      ...IntroImages
    }
  }
`;
